import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 36 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, index = 0, className = "", as = "span" }) {
  const Tag = motion[as] || motion.span;
  return (
    <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
      <Tag
        className={`block will-change-transform ${className}`}
        initial={{ y: "115%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.2 + index * 0.13 }}
      >
        {children}
      </Tag>
    </span>
  );
}
